import { render, staticRenderFns } from "./serviciosCli.vue?vue&type=template&id=197095d2&scoped=true&"
import script from "./serviciosCli.vue?vue&type=script&lang=js&"
export * from "./serviciosCli.vue?vue&type=script&lang=js&"
import style0 from "./serviciosCli.vue?vue&type=style&index=0&id=197095d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197095d2",
  null
  
)

export default component.exports